"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useEscapeHandler = _interopRequireDefault(require("../useEscapeHandler"));

var _useOutsideClick = _interopRequireDefault(require("../useOutsideClick"));

var _usePopover = require("./usePopover.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ARROW_SIZE = 8;
/**
 * The Popover Component sets a span immediately after its anchor element.
 * It then absolutely positions itself in relation to its parent.
 * This is why we provide the PopoverWrapper (unnecesary if the anchor's parent has positioning set)
 */

var Popover = function Popover(_ref) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      position = _ref.position,
      align = _ref.align,
      arrowSize = _ref.arrowSize,
      children = _ref.children,
      anchorRef = _ref.anchorRef;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      root = _useState2[0],
      setRoot = _useState2[1];

  (0, _useOutsideClick["default"])(function () {
    if (isOpen) close(); // prevents running when initially opening the popover
  }, [], ref);
  (0, _useEscapeHandler["default"])(close);
  (0, _react.useEffect)(function () {
    if (anchorRef.current) {
      var elem = document.createElement('span');

      var _root = anchorRef.current.appendChild(elem);

      setRoot(_root);
    }

    return function () {
      root === null || root === void 0 ? void 0 : root.remove();
    };
  }, [anchorRef]);
  return isOpen && root ? /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_usePopover.PopoverBody, {
    position: position,
    align: align,
    arrowSize: arrowSize,
    role: "dialog",
    ref: ref
  }, children), root) : null;
};

Popover.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  anchorRef: _propTypes["default"].shape({}).isRequired,
  align: _propTypes["default"].oneOf(['start', 'end']),
  arrowSize: _propTypes["default"].number,
  position: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left'])
};
Popover.defaultProps = {
  arrowSize: ARROW_SIZE,
  position: 'bottom',
  align: 'end'
};
var _default = Popover;
exports["default"] = _default;